import React from 'react'
import PermanenceTotalsDetailSimple from './PermanenceTotalsDetailSimple'
import { getTenantInfoByKey } from '../../../../helpers/helpers'

const PermanenceTotalsDetailListSimple = ({ totalsReports }) => {

    const haveBuildings = getTenantInfoByKey('is_building');
    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const haveAccessOpeningsAndBuildings = haveAccessOpenings === true && haveBuildings === true

    const haveBuildingsAndNoOpenings = haveAccessOpenings === false && haveBuildings === true;

    const codeKey = haveBuildingsAndNoOpenings ? 'building_code' : 'opening_code';
    const descriptionKey = haveBuildingsAndNoOpenings ? 'building_description' : 'opening_description';

    return (
        <div>
            <div className={`d-flex ${haveAccessOpeningsAndBuildings ? 'gap-3' : ''} flex-column no-show-scroll`} style={{ overflowX: 'auto', maxHeight: '680px' }}>
                {totalsReports.map((totalsReport, idx) =>
                    <div className={`${haveAccessOpeningsAndBuildings ? 'border border-primary' : ''}`} key={idx}>
                        <PermanenceTotalsDetailSimple
                            totalsReport={totalsReport}
                            codeKey={codeKey}
                            descriptionKey={descriptionKey}
                        />
                        {(haveAccessOpeningsAndBuildings) && (
                            totalsReport.buildings.map((totalsBuildingReport, idx) =>
                                <PermanenceTotalsDetailSimple
                                    key={idx}
                                    totalsReport={totalsBuildingReport}
                                    codeKey={'building_code'}
                                    descriptionKey={'building_description'}
                                />
                            )
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default PermanenceTotalsDetailListSimple